import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface WithActionsProps {
  closeButton: string;
  setOpen: (state: boolean) => void;
  children?: ReactNode;
  additionalButtons?: ReactNode; // Add support for additional buttons
}

export const WithActions = ({ closeButton = "Close", setOpen, children, additionalButtons }: WithActionsProps) => (
  <div
    className={twMerge("mt-5", (children || additionalButtons) && "grid gap-3 sm:grid-flow-row-dense sm:grid-cols-2")}
  >
    <div className="flex items-center justify-center">
      <span className="cursor-pointer text-xs leading-6 text-secondary" onClick={() => setOpen(false)}>
        {closeButton}
      </span>
    </div>
    {additionalButtons && <div className="flex justify-end gap-2">{additionalButtons}</div>}
    {children}
  </div>
);
